import React from 'react';
import { Typography } from '@material-ui/core';

import { PropsType } from 'components/Typography/types';
import styled from 'styled-components';

const StyledCaptions = styled(({ color, weight, ...otherProps }) => (
  <Typography {...otherProps} />
))`
  font-size: 12px !important;
  font-weight: ${(props) => props.weight} !important;
  color: ${(props) => props.color} !important;
`;

const Captions = (props: PropsType) => {
  return (
    <StyledCaptions variant="h6" {...props}>
      {props.children}
    </StyledCaptions>
  );
};

export default Captions;
